import { ISubStepData } from "../../models/freshman/subStep";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { subStep } from "../../constants/apiUrl";
import { urlBinder } from "../../helper/url-binder";
import { IDropdownData } from "../../models/ICommon";

export default new (class SubStepService {
    public getSubStep = async (id: number): Promise<IApiResponse<ISubStepData>> => {
        try {
            let endPoint = urlBinder(subStep.GET_SUBSTEP, [`${id}`]);
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<ISubStepData>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<ISubStepData>;
            } else {
                throw error;
            }
        }
    };

    public getSubSteps = async (includeInactive?: boolean): Promise<IApiResponse<Array<ISubStepData>>> => {
        try {
            let endPoint = urlBinder(subStep.GET_ALL_SUBSTEP, [`${includeInactive}`]);
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<Array<ISubStepData>>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<Array<ISubStepData>>;
            } else {
                throw error;
            }
        }
    };

    public createSubStep = async (
        data: any
    ): Promise<IApiResponse<boolean | any>> => {
        try {
            let endPoint = subStep.CREATE_SUBSTEP;
            const response = await APIService.post(endPoint, data);
            return response.data as IApiResponse<boolean | any>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<boolean | any>;
            } else {
                throw error;
            }
        }
    };

    public updateSubStep = async (
        data: any,
        id: number
    ): Promise<IApiResponse<boolean>> => {
        try {
            let endPoint = urlBinder(subStep.UPDATE_SUBSTEP, [`${id}`]);
            const response = await APIService.put(endPoint, data);
            return response.data as IApiResponse<boolean>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<boolean>;
            } else {
                throw error;
            }
        }
    };

    public inactivateSubStep = async (id: number): Promise<boolean> => {
        try {
            let endPoint = urlBinder(subStep.INACTIVATE_SUBSTEP, [`${id}`]);
            const response = await APIService.delete(endPoint);
            return response.status === 204 ? true : false;
        } catch (error: any) {
            if (error.response) {
                return false as boolean;
            } else {
                throw error;
            }
        }
    };

    public getAllSubStepsKeyValuePair = async (): Promise<IApiResponse<Array<IDropdownData>>> => {
        try {
            let endPoint = subStep.KEY_VALUE_PAIR;
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<Array<IDropdownData>>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<Array<IDropdownData>>;
            } else {
                throw error;
            }
        }
    };
})